import State from '../core/State';
import initialState from '../initialState';

export const setSnackbar = ({
  message,
  messageValues,
  action,
  actionValues,
  isRaw,
  onClickAction,
}: {
  message: string;
  messageValues: Record<string, any> | null;
  action: string | null;
  actionValues: Record<string, any> | null;
  isRaw: boolean;
  onClickAction: (() => void) | null;
}) => (state: State) => ({
  ...state,
  snackbar: {
    message,
    messageValues,
    action,
    actionValues,
    isRaw,
    onClickAction,
  },
});

export const clearSnackbar = () => (state: State) => ({
  ...state,
  snackbar: initialState.snackbar,
});
